import { useMemo } from 'react';
import { getGlobalDataStore } from '@/lib/mock-data/global-data-store';

/**
 * Hook to fetch collection cases for a specific customer
 * Filters all collection cases by customer ID
 */
export function useCustomerCollectionCases(customerId: string | undefined) {
  const cases = useMemo(() => {
    if (!customerId) return [];
    
    const store = getGlobalDataStore();
    const allCases = store.getAllCases();
    
    // Filter cases by customer ID
    return allCases.filter(c => c.customerId === customerId);
  }, [customerId]);
  
  return {
    cases,
    isLoading: false,
    error: null
  };
}
